module.exports = __webpack_public_path__ + "static/media/qbrick-logo.1f1e60af.png";